import { render } from "./UserList.vue?vue&type=template&id=639cd79e&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=639cd79e&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639cd79e"]])

export default __exports__